"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.testIds = void 0;
exports.testIds = {
    removeFileButton: "remove-file-button",
};
